import machineHarvestDrone from "../assets/enemies/machine-harvest-drone.png";
import machineSilo from "../assets/enemies/machine-silo.png";
import machineTractor from "../assets/enemies/machine-tractor.png";
import machineTruck from "../assets/enemies/machine-truck.png";
import machineWarehouseTug from "../assets/enemies/machine-warehouse-tug.png";
import produceApple from "../assets/enemies/produce-apple.png";
import produceBroccoli from "../assets/enemies/produce-broccoli.png";
import produceCorn from "../assets/enemies/produce-corn.png";
import producePepper from "../assets/enemies/produce-pepper.png";
import produceWatermelon from "../assets/enemies/produce-watermelon.png";
import type { EnemySpriteId } from "../core/enemies";

export const ENEMY_IMAGE_URLS: Readonly<Record<EnemySpriteId, string>> = {
  "machine-harvest-drone": machineHarvestDrone,
  "machine-silo": machineSilo,
  "machine-tractor": machineTractor,
  "machine-truck": machineTruck,
  "machine-warehouse-tug": machineWarehouseTug,
  "produce-apple": produceApple,
  "produce-broccoli": produceBroccoli,
  "produce-corn": produceCorn,
  "produce-pepper": producePepper,
  "produce-watermelon": produceWatermelon,
};
